export const Row = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28 7L4 7" stroke="currentColor" stroke-width="2"/>
<path d="M28 25L4 25" stroke="currentColor" stroke-width="2"/>
<rect x="27" y="13" width="6" height="22" rx="1" transform="rotate(90 27 13)" stroke="currentColor" stroke-width="2"/>
</svg>`;
